import { Trans } from '@lingui/react/macro';
import { TireQuoteRecordCustomer } from '@navio/nsdk';

import { useTireOfferPickerStore } from '../../../../stores/tireOfferPickerStore';
import { ModeBanner } from './ModeBanner';
import { OfferRow } from './OfferRow';

type PendingTabProps = {
  offers: TireQuoteRecordCustomer[];
};

export const PendingTab = ({ offers }: PendingTabProps) => {
  const mode = useTireOfferPickerStore((state) => state.mode);
  const bulkStrategy = useTireOfferPickerStore((state) => state.bulkStrategy);
  const setBulkStrategy = useTireOfferPickerStore((state) => state.setBulkStrategy);
  const selectedQuoteItemId = useTireOfferPickerStore((state) => state.selectedQuoteItemId);
  const selectOption = useTireOfferPickerStore((state) => state.selectOption);

  if (offers.length === 0) {
    return (
      <div className='rounded-xl border border-border bg-card p-12 text-center'>
        <div className='text-base font-semibold text-foreground'>
          <Trans>All caught up</Trans>
        </div>
        <div className='mt-1 text-sm text-muted-foreground'>
          <Trans>No pending tire offers — you'll be notified when new ones arrive.</Trans>
        </div>
      </div>
    );
  }

  return (
    <div className='flex flex-col gap-4'>
      <ModeBanner mode={mode} strategy={bulkStrategy} onStrategyChange={setBulkStrategy} />

      <div className='overflow-hidden rounded-xl border border-border bg-card shadow-xs'>
        <div className='hidden grid-cols-[28px_minmax(180px,220px)_1fr_minmax(110px,140px)] items-center gap-4 border-b border-border bg-muted px-4 py-2.5 text-[11px] font-medium tracking-wider text-muted-foreground uppercase md:grid'>
          <div />
          <div>
            <Trans>Vehicle / customer</Trans>
          </div>
          <div className='grid grid-cols-3 gap-2'>
            <div>
              <Trans>Option 1</Trans>
            </div>
            <div>
              <Trans>Option 2</Trans>
            </div>
            <div>
              <Trans>Option 3</Trans>
            </div>
          </div>
          <div className='text-right'>
            <Trans>Total</Trans>
          </div>
        </div>

        {offers.map((offer) => (
          <OfferRow
            key={offer.id}
            offer={offer}
            selectedQuoteItemId={selectedQuoteItemId[offer.id]}
            onSelectQuoteItem={(quoteItemId) => selectOption(offer.id, quoteItemId)}
          />
        ))}
      </div>
    </div>
  );
};
